
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__roadmap__/[slug]",
      function () {
        return require("private-next-pages/__roadmap__/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__roadmap__/[slug]"])
      });
    }
  